// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"538":"33ad2e16","735":"958046f7"}[chunkId] + ".chunk.css";
};